<template>
  <div class="statisticsRootBox">
    <div class="statistics_1">
      <div class="statistics_content">
        <div>{{ statisticsData.runningDays || 0 }}</div>
        <div>运行天数</div>
      </div>
    </div>
    <div class="statistics_2">
      <div class="statistics_content">
        <div>{{ statisticsData.teachingClassCount || 0 }}</div>
        <div>教学班</div>
      </div>
    </div>
    <div class="statistics_3">
      <div class="statistics_content">
        <div>{{ statisticsData.administrativeCount || 0 }}</div>
        <div>行政班</div>
      </div>
    </div>
    <div class="statistics_4">
      <div class="statistics_content">
        <div>
          <span>
            {{ statisticsData.adminCount || 0 }}
          </span>
          <span style="color: red"> (占比 {{ adminCountPercent }}% ) </span>
        </div>
        <div>注册管理员</div>
      </div>
    </div>
    <div class="statistics_5">
      <div class="statistics_content">
        <div>
          <span>
            {{ statisticsData.teacherCount || 0 }}
          </span>
          <span style="color: red"> (占比 {{ teacherCountPercent }}% ) </span>
        </div>
        <div>注册教师</div>
      </div>
    </div>
    <div class="statistics_6">
      <div class="statistics_content">
        <div>
          <span>
            {{ statisticsData.studentCount || 0 }}
          </span>
          <span style="color: red"> (占比 {{ studentCountPercent }}% ) </span>
        </div>
        <div>注册学生</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mStatistics",
  props: {
    statisticsData: {
      type: Object,
      default: () => ({
        runningDays: "",
        adminCount: "",
        teacherCount: "",
        studentCount: "",
        teachingClassCount: "",
        administrativeCount: "",
      }),
    },
  },
  data() {
    return {
      adminCountPercent: 0,
      teacherCountPercent: 0,
      studentCountPercent: 0,
    };
  },
  watch: {
    statisticsData: {
      handler(val) {
        // 计算占比
        if (val.studentCount) {
          let sum = 0;
          let subLast = (str) => {
            return Number(str.substring(0, str.length - 1));
          };
          let s1 = subLast(this.statisticsData.adminCount);
          let s2 = subLast(this.statisticsData.teacherCount);
          let s3 = subLast(this.statisticsData.studentCount);

          sum = s1 + s2 + s3;
          this.adminCountPercent = ((s1 / sum) * 100).toFixed(2);
          this.teacherCountPercent = ((s2 / sum) * 100).toFixed(2);
          this.studentCountPercent = (
            100 -
            Number(this.adminCountPercent) -
            Number(this.teacherCountPercent)
          ).toFixed(2);
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
.statisticsRootBox {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: calc(0.12 * var(--fontSize));

  & > div {
    width: 100%;
    height: 100%;
    border-radius: calc(0.19 * var(--fontSize));
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(255, 255, 255, 1);
    box-shadow: 4px 4px 10px 0px rgba(222, 221, 227, 1);
  }

  & > div[class^="statistics"] {
    display: flex;
    align-items: center;
    transition: 0.5s all;
    &:hover {
      transform: scale(0.9);
    }
  }

  & > .statistics_1 {
    grid-column: 1 / span 5;
    background: url("../../../../../../../src/assets/icon/icon_begin.png")
      no-repeat right 10% top 50%;
    background-size: calc(0.8 * var(--fontSize)) calc(0.8 * var(--fontSize));
  }

  & > .statistics_2 {
    grid-column: 6 / span 2;
    background: url("../../../../../../../src/assets/icon/icon_jiaoxue.png")
        no-repeat right 10% top 10%,
      linear-gradient(180deg, #f2f7ff, #fffdff, #ffffff) no-repeat;
    background-size: calc(0.24 * var(--fontSize)) calc(0.24 * var(--fontSize)),
      100% 100%;
  }

  & > .statistics_3 {
    grid-column: 8 / span 2;
    background: url("../../../../../../../src/assets/icon/icon_xingzheng.png")
        no-repeat right 10% top 10%,
      linear-gradient(180deg, #faf6e9, #faffff, #ffffff) no-repeat;
    background-size: calc(0.24 * var(--fontSize)) calc(0.24 * var(--fontSize)),
      100% 100%;
  }

  & > .statistics_4 {
    grid-column: 1 / span 3;
    background: url("../../../../../../../src/assets/icon/icon_guanli.png")
      no-repeat right -8px bottom -40px;
    background-size: calc(0.92 * var(--fontSize)) calc(1.1 * var(--fontSize));
  }

  & > .statistics_5 {
    grid-column: 4 / span 3;
    background: url("../../../../../../../src/assets/icon/icon_jiaoshi.png")
      no-repeat right 0 bottom -10px;
    background-size: calc(0.88 * var(--fontSize)) calc(0.88 * var(--fontSize));
  }

  & > .statistics_6 {
    grid-column: 7 / span 3;
    background: url("../../../../../../../src/assets/icon/icon_xuesheng.png")
      no-repeat right -38px bottom -14px;
    background-size: calc(1.15 * var(--fontSize)) calc(0.9 * var(--fontSize));
  }

  .statistics_content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(0.68 * var(--fontSize));
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 8%;
    span {
      font-size: calc(0.14 * var(--fontSize));
    }
    & > div:first-child {
      font-size: calc(0.24 * var(--fontSize));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mStatistics.vue